<app-help-page mainVideo="export-destinations"
               [tutorials]="['export-destination-ftp']"
               [videos]="['export-destinations', 'exports']"></app-help-page>
